// Translation for bn
export const bn = {
        common: {
            save: 'সংরক্ষণ করুন',
            cancel: 'বাতিল করুন',
            close: 'বন্ধ করুন',
            delete: 'মুছে ফেলুন',
            edit: 'সম্পাদনা করুন',
            activate: 'সক্রিয় করুন',
            add: 'যোগ করুন',
            saving: 'সংরক্ষণ করা হচ্ছে...',
            loading: 'লোড হচ্ছে...',
            active: 'সক্রিয়',
            inUse: 'ব্যবহৃত হচ্ছে',
            test: 'পরীক্ষা',
            searchApps: 'অ্যাপ খুঁজুন...',
            betaBanner: 'বিটা - পরিষেবাটি এখনও উপলব্ধ নয়!'
        },
        header: {
            creditBalance: 'ব্যালেন্স',
            minutes: 'মিনিট'
        },
        auth: {
            signIn: 'সাইন ইন করুন',
            signUp: 'সাইন আপ করুন',
            username: 'ব্যবহারকারীর নাম',
            password: 'পাসওয়ার্ড',
            continue: 'চালিয়ে যান',
            noAccount: 'আপনার কি অ্যাকাউন্ট নেই?',
            hasAccount: 'ইতিমধ্যে একটি অ্যাকাউন্ট আছে?',
            loginError: 'লগইন ব্যর্থ হয়েছে',
            invalidCredentials: 'অকার্যকর ব্যবহারকারীর নাম বা পাসওয়ার্ড',
            rateLimited: 'খুব বেশি লগইন চেষ্টা। অনুগ্রহ করে কিছুক্ষণ অপেক্ষা করুন।',
            sessionExpired: 'আপনার সেশন শেষ হয়ে গেছে। অনুগ্রহ করে একটি নতুন ম্যাজিক লিঙ্ক ব্যবহার করুন।',
            magicLinkInvalid: 'লগইন লিঙ্কটি অবৈধ বা মেয়াদ শেষ হয়ে গেছে।',
            magicLinkSuccess: 'স্বাগতম! আপনি সফলভাবে লগ ইন করেছেন।',
            magicLinkProcessing: 'লগইন প্রক্রিয়া করা হচ্ছে...',
            connectionError: 'সংযোগ ত্রুটি। অনুগ্রহ করে আবার চেষ্টা করুন।'
        },
        profile: {
            myProgress: 'আমার শেখার অগ্রগতি',
            signOut: 'সাইন আউট',
            plan: 'প্ল্যান: '
        },
        settings: {
            title: 'সেটিংস',
            tabs: {
                uiSettings: 'UI সেটিংস',
                systemPrompt: 'সিস্টেম প্রম্পট',
                llmProfiles: 'LLM প্রোফাইল',
                ttsProfiles: 'TTS প্রোফাইল',
                language: 'ভাষা',
            },
            uiSettings: {
                title: 'ইউজার ইন্টারফেস',
                themeMode: 'থিম মোড',
                darkMode: 'ডার্ক মোড',
                lightMode: 'লাইট মোড',
                themeColor: 'থিম রঙ',
                themeColorDesc: 'বোতাম, আইকন এবং হাইলাইটের জন্য অ্যাকসেন্ট রঙ চয়ন করুন',
                background: 'ব্যাকগ্রাউন্ড',
                backgroundDesc: 'আপনার ওয়ার্কস্পেসের জন্য একটি ব্যাকগ্রাউন্ড চয়ন করুন',
                selectBackgroundColor: 'ব্যাকগ্রাউন্ড রঙ চয়ন করুন',
                backgrounds: {
                    cyberSchooling: 'সাইবার স্কুলিং',
                    focus: 'ফোকাস',
                    concentration: 'একাগ্রতা',
                    relaxation: 'বিশ্রাম',
                    lianas: 'লিয়ানাস',
                    color: 'রঙ'
                },
                backgroundColors: {
                    deepDark: 'গাঢ় অন্ধকার',
                    darkGrey: 'গাঢ় ধূসর',
                    midnightBlue: 'মিডনাইট ব্লু',
                    indigo: 'ইন্ডিগো',
                    darkTeal: 'গাঢ় টিল',
                    brown: 'বাদামী',
                    darkRed: 'গাঢ় লাল',
                    deepPurple: 'গাঢ় বেগুনি',
                    pureWhite: 'খাঁটি সাদা',
                    softWhite: 'নরম সাদা',
                    lightGrey: 'হালকা ধূসর',
                    paleBlue: 'ফ্যাকাশে নীল',
                    paleGreen: 'ফ্যাকাশে সবুজ',
                    paleOrange: 'ফ্যাকাশে কমলা',
                    lavender: 'ল্যাভেন্ডার',
                    blueGrey: 'ব্লু গ্রে'
                }
            },
            systemPrompt: {
                label: 'সিস্টেম প্রম্পট:',
                placeholder: 'সিস্টেম প্রম্পট লোড হচ্ছে...',
                emptyError: 'সিস্টেম প্রম্পট খালি হতে পারে না!',
                saveSuccess: '✓ সিস্টেম প্রম্পট সফলভাবে সংরক্ষিত হয়েছে!',
                loadError: 'সিস্টেম প্রম্পট লোড করতে ত্রুটি',
                saveError: 'সংরক্ষণ করতে ত্রুটি'
            },
            llmProfiles: {
                addButton: '+ নতুন সংযোগ যোগ করুন',
                newConnection: 'নতুন সংযোগ',
                editConnection: 'সংযোগ সম্পাদনা করুন',
                emptyState: 'কোনো LLM সংযোগ উপলব্ধ নেই। যোগ করতে নিচে ক্লিক করুন।',
                loadingProfiles: 'প্রোফাইল লোড হচ্ছে...',
                nameLabel: 'নাম *',
                namePlaceholder: 'যেমন: OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API কী *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'মডেল *',
                modelPlaceholder: 'gpt-4, mistral-tiny, ইত্যাদি।',
                allFieldsRequired: 'সব ঘর পূরণ করতে হবে!',
                saveSuccess: '✓ প্রোফাইল সফলভাবে সংরক্ষিত হয়েছে!',
                deleteConfirm: 'আপনি কি সত্যিই "{name}" মুছতে চান?',
                profileNotFound: 'প্রোফাইল পাওয়া যায়নি!',
                loadError: 'প্রোফাইল লোড করতে ত্রুটি',
                saveError: 'সংরক্ষণ করতে ত্রুটি',
                activateError: 'সক্রিয় করতে ত্রুটি',
                deleteError: 'মুছতে ত্রুটি',
                modelInfo: 'মডেল: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ নতুন ভয়েস যোগ করুন',
                newVoice: 'নতুন ভয়েস',
                editVoice: 'ভয়েস সম্পাদনা করুন',
                emptyState: 'কোনো TTS প্রোফাইল উপলব্ধ নেই। যোগ করতে নিচে ক্লিক করুন।',
                loadingProfiles: 'TTS প্রোফাইল লোড হচ্ছে...',
                nameLabel: 'নাম',
                namePlaceholder: 'যেমন: My ElevenLabs Adam',
                providerLabel: 'প্রদানকারী',
                providerPlaceholder: 'যেমন: ElevenLabs, OpenAI, Piper',
                providerPiper: 'পাইপার (স্থানীয়)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API কী *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'মডেল ID *',
                modelIdPlaceholder: 'যেমন: eleven_monolingual_v1',
                voiceIdLabel: 'ভয়েস ID',
                voiceIdPlaceholder: 'যেমন: pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'সব ঘর পূরণ করতে হবে!',
                saveSuccess: '✓ TTS প্রোফাইল সফলভাবে সংরক্ষিত হয়েছে!',
                deleteConfirm: 'আপনি কি সত্যিই "{name}" মুছতে চান?',
                loadError: 'TTS প্রোফাইল লোড করতে ত্রুটি',
                saveError: 'সংরক্ষণ করতে ত্রুটি',
                activateError: 'সক্রিয় করতে ত্রুটি',
                deleteError: 'মুছতে ত্রুটি'
            },
            language: {
                title: 'ভাষা চয়ন করুন',
                description: 'ইউজার ইন্টারফেসের জন্য আপনার পছন্দের ভাষা নির্বাচন করুন'
            },
        },
        chat: {
            ready: 'প্রস্তুত',
            start: 'শুরু করুন',
            stop: 'বন্ধ করুন',
            initialMessage: 'রিয়েল-টাইম কথোপকথনের জন্য শুরু করুন ক্লিক করুন।',
            listening: 'শুনছি...',
            speaking: 'থর্স্টেন কথা বলছে...',
            userLabel: 'আপনি',
            aiLabel: 'AI',
            modalTitle: 'থর্স্টেন AI চ্যাট',
            inputPlaceholder: 'একটি বার্তা টাইপ করুন...',
            send: 'পাঠান',
            loginRequired: 'এই পরিষেবাটি ব্যবহার করতে অনুগ্রহ করে সাইন ইন করুন৷',
            loginButton: 'এখনই সাইন ইন করুন',
            magicLinkRequired: 'সাইন ইন করতে অনুগ্রহ করে একটি ম্যাজিক লিঙ্ক ব্যবহার করুন।',
            creditLimitError: 'আপনার প্রতি ঘণ্টার কোটা শেষ হয়ে গেছে। চালিয়ে যেতে অনুগ্রহ করে আপনার প্ল্যান (মিডিয়াম/প্রিমিয়াম) আপগ্রেড করুন।',
            serviceDisabled: 'চ্যাট সেবা বর্তমানে অনুপলব্ধ। অনুগ্রহ করে পরে আবার চেষ্টা করুন।'
        },
        notifications: {
            error: 'ত্রুটি',
            success: 'সফলতা',
            info: 'তথ্য',
            unknownError: 'একটি অজানা ত্রুটি ঘটেছে'
        },
        cookie: {
            message: 'এই ওয়েবসাইটটি আপনাকে সম্ভাব্য সর্বোত্তম ব্যবহারকারীর অভিজ্ঞতা দিতে কুকিজ ব্যবহার করে।',
            accept: 'সম্মত'
        },
        curriculum: {
                buttonLabel: 'পাঠ্যক্রম',
                buttonTitle: 'পাঠ্যক্রমের বিষয়বস্তু দেখান',
                modalTitle: '{app} পাঠ্যক্রম',
                sections: {
                    topic: 'পাঠ্যক্রমের বিষয়',
                    explanation: 'শিশু-বান্ধব ব্যাখ্যা',
                    studentProfile: 'শিক্ষার্থী প্রোফাইল'
                },
                topic: {
                    empty: 'ব্যাকএন্ডে এই মাইক্রো-অ্যাপের সাথে কোনো পাঠ্যক্রমের বিষয় লিঙ্ক করা নেই।',
                    missingDetail: 'এই মাইক্রো-অ্যাপের জন্য বিস্তারিত পাঠ্যক্রম তথ্য এখনও ব্যাকএন্ডে উপলব্ধ নয়।',
                    learningGoals: 'শেখার লক্ষ্য',
                    prerequisites: 'পূর্বশর্ত',
                    unitLabel: 'ইউনিট',
                    durationLabel: 'সময়কাল',
                    difficultyLabel: 'কঠিনতা',
                    hours: 'ঘণ্টা',
                    minutes: 'মিনিট'
                },
                explanation: {
                    empty: 'কোনো শিশু-বান্ধব ব্যাখ্যা উপলব্ধ নেই।',
                    loadingPrepare: 'AI ব্যাখ্যা প্রস্তুত করছে',
                    loadingExplain: 'AI শিশু-বান্ধব ভাষায় বিষয়টি ব্যাখ্যা করছে',
                    requestFailed: 'শিশু-বান্ধব ব্যাখ্যা তৈরি করা যায়নি।'
                },
                studentProfile: {
                    country: 'দেশ',
                    region: 'রাজ্য / অঞ্চল',
                    schoolType: 'স্কুলের ধরন',
                    grade: 'শ্রেণি',
                    noContext: 'কোনো শিক্ষার্থী প্রসঙ্গ উপলব্ধ নেই।',
                    childProfileNotFound: 'বর্তমান লগইনের জন্য ব্যাকএন্ডে কোনো শিক্ষার্থী প্রোফাইল পাওয়া যায়নি।',
                    loginProfileIncomplete: 'লগইন প্রোফাইলে এখনও সম্পূর্ণ শিক্ষার্থী প্রসঙ্গ নেই।',
                    educationContextNotFound: 'একটি শিক্ষার্থী প্রোফাইল পাওয়া গেছে, কিন্তু কোনো পাঠ্যক্রম নির্ধারণ করা নেই।',
                    noToken: 'কোনো সাইন-ইন করা শিক্ষার্থী পাওয়া যায়নি।'
                },
                errors: {
                    signInRequired: 'পাঠ্যক্রম দেখতে অনুগ্রহ করে সাইন ইন করুন।',
                    appIdMissing: 'অ্যাপ আইডি অনুপস্থিত।',
                    loadFailed: 'পাঠ্যক্রম তথ্য লোড করা যায়নি।'
                }
            }
    };
